import {
  ImageIcon,
  PlusCircleIcon,
  ProjectRoadmapIcon
} from "@primer/octicons-react";
import { Box, IconButton, Tooltip } from "@primer/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TagBoxCauHoiCoSan } from "../../components/tagbox-cauhoicosan";
import Text from "../../components/ui/text";
import { useCommonContext } from "../../contexts/common";
import { ePageBaseStatus } from "../../models/ePageBaseStatus";
import { ICrmSurveyFormQuestion } from "../../models/response/crm-survey/ICrmSurveyFormQuestion";
import { actions } from "../../state/actions/actionsWrapper";
import { RootState } from "../../state/reducers";
interface ISurveyFormBlockProps {
  formQuestionSelectedIds: number[];
  children: React.ReactNode;
  isFocused?: boolean;
  elementKey?: string;
  onFocused?: (elementKey: string) => void;
  // refIni?: any,
  onDragStart?: (e: any) => void;
  onDragOver?: (e: any) => void;
  onDragEnd?: (e: any) => void;
  onAddNew?: () => void;
  onAddFormExisted?: (questions: ICrmSurveyFormQuestion[]) => void;
  onValueChanged?: (ids: number[]) => void;

}

const SurveyFormBlock = (props: ISurveyFormBlockProps) => {
  const dispatch = useDispatch();
  const { translate } = useCommonContext();
  const { status, crmSurveyFormQuestions, crmSurveyFormQuestionSelectedIds } = useSelector(
    (x: RootState) => x.crmSurvey.crmSurveyFormQuestion
  );
  const [questionSelectedIds, setQuestionSelectedIds] = useState<number[]>(props.formQuestionSelectedIds || []);

  useEffect(() => {
    if (status === ePageBaseStatus.is_not_initialization) {
      dispatch(actions.crmSurveyFormWrapper.crmSurveyFormQuestion.CHANGE_SELECTED_IDS([]));
      dispatch(actions.crmSurveyFormWrapper.crmSurveyFormQuestion.LOAD_START(''));
    }
  }, []);
  useEffect(() => {
    if (props.formQuestionSelectedIds.length > 0 && questionSelectedIds.length == 0) {
      setQuestionSelectedIds(props.formQuestionSelectedIds)
    }
  }, [props.formQuestionSelectedIds]);
  useEffect(() => {
    // Lấy các câu hỏi từ crmSurveyFormQuestions dựa trên crmSurveyFormQuestionSelectedIds
    const selectedQuestions = crmSurveyFormQuestions.filter((question) =>
      questionSelectedIds.includes(question.id)
    );
    // Gọi hàm onAddFormExisted và truyền vào các câu hỏi đã chọn nếu có
    if (props.onAddFormExisted) {
      if (selectedQuestions.length > 0) {
        props.onAddFormExisted(selectedQuestions);
      }
    }
  }, [questionSelectedIds, crmSurveyFormQuestions]);

  return (
    <Box>
      <Box
        sx={{ position: "relative", display: "flex", flexDirection: "column" }}
      >
        {props.isFocused && (
          <Box
            sx={{
              ml: "-8px",
              position: "absolute",
              height: "100%",
              pt: 2,
              pb: 3,
            }}
          >
            <Box
              sx={{
                backgroundColor: "#0969da",
                width: "8px",
                height: "100%",
                borderTopLeftRadius: "8px",
                borderBottomLeftRadius: "8px",
              }}
            >
              &nbsp;
            </Box>
          </Box>
        )}
        <Box
          sx={{
            position: "relative",
            border: "1px solid",
            borderRadius: 2,
            borderColor: "border.default",
            backgroundColor: "#ffff",
            p: 3,
            pl: 3,
            pr: 3,
            mb: 2,
            flex: 1,
            cursor: "pointer",
          }}
          draggable
          onClick={() => {
            if (props.onFocused) {
              props.onFocused(props.elementKey ?? "");
            }
          }}
          id={props.elementKey}
          onDragStart={props.onDragStart}
          onDragOver={props.onDragOver}
          onDragEnd={props.onDragEnd}
          onDrop={(e) => {
            e.preventDefault();
          }}
        >
          {props.children}
        </Box>
      </Box>
      {props.isFocused && (
        <Box
          sx={{
            mb: 2,
            p: 3,
            border: "1px solid",
            borderColor: "border.default",
            borderRadius: 2,
          }}
        >
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box sx={{ mb: 0, flexShrink: 0, mr: 3 }}>
                <Text
                  text="Thêm câu hỏi mới tại đây"
                  sx={{
                    color: "fg.muted",
                  }}
                />
              </Box>

              <Tooltip aria-label="Câu hỏi mới" direction="n">
                <IconButton
                  icon={PlusCircleIcon}
                  variant="invisible"
                  size="medium"
                  aria-label="Thêm mới"
                  onClick={() => {
                    if (props.onAddNew) {
                      props.onAddNew();
                    }
                  }}
                />
              </Tooltip>

              <IconButton
                icon={ProjectRoadmapIcon}
                variant="invisible"
                size="medium"
                aria-label=""
              />

              <IconButton
                icon={ImageIcon}
                variant="invisible"
                size="medium"
                aria-label=""
              />

              <TagBoxCauHoiCoSan
                isReadonly={false}
                value={questionSelectedIds}
                onValueChanged={(ids) => {
                  // dispatch(actions.crmSurveyFormWrapper.crmSurveyFormQuestion.CHANGE_SELECTED_IDS(ids));
                  setQuestionSelectedIds(ids);
                }}
                isShowClearButton={true}
                preText="Select question"
                stylingMode="outlined"
                sx={{
                  ml: "20px",
                }}
              />
            </Box>
          </Box>

        </Box>
      )}
    </Box>
  );
};

export default SurveyFormBlock;
